module.exports = __webpack_public_path__ + "static/img/kongtiao-chushi.453b7a02.png";